/**
 * @file       Students routes, used by the whole students module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { ifAuthenticated } from "@/router/navigationGuards";
import { ifStudent } from "@/router/navigationGuards";

import Base from "@/modules/students/base.vue";
import Deliberations from "@/modules/students/components/deliberations.vue";
import StudentProfile from "@/modules/admin/components/studentProfile.vue";

/**
 * Students routes.
 *
 * @type  {array}
 */
const routes = [
  {
    path: "/etudiants",
    component: Base,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "deliberations",
        component: Deliberations,
        name: "student.deliberations",
        meta: { layout: "basic" },
        beforeEnter: ifStudent
      },
      {
        path: ":id/deliberations",
        component: Deliberations,
        name: "student.own.deliberations",
        meta: { layout: "basic" },
        beforeEnter: ifStudent
      },
      {
        path: ":id/resultats",
        component: StudentProfile,
        name: "student.results",
        meta: { layout: "basic" },
        beforeEnter: ifStudent
      }
    ]
  }
];

export default routes;
